import { filterByPolicyType } from "../../src/helpers/filters";

/* constants for verticals  */
export const IR_AUTO_INSURANCE_DEFAULT_PATH = "auto-insurance";
export const IR_LIFE_INSURANCE_DEFAULT_PATH = "life-insurance";
export const IR_HOMEOWNERS_INSURANCE_DEFAULT_PATH = "homeowners-insurance";
export const IR_HEALTH_INSURANCE_DEFAULT_PATH = "health-insurance";
export const IR_PET_INSURANCE_DEFAULT_PATH = "pet-insurance";
export const IR_RENTERS_INSURANCE_DEFAULT_PATH = "renters-insurance";
export const DISABILITY_INSURANCE_DEFAULT_PATH = "disability-insurance";
export const BUSINESS_INSURANCE_PATH = "business-insurance";
export const TRAVEL_INSURANCE_PATH = "travel-insurance";
export const VISION_INSURANCE_PATH = "vision-insurance";
export const IR_PHONE_INSURANCE_PATH = "phone-insurance";
export const EVENT_INSURANCE_PATH = "event-insurance";
export const IR_WHOLE_LIFE_INSURANCE_PATH = "whole-life-insurance";

/* URL filter parameters */
export const SHORT_TERM_POLICY_TYPE_URL_PARAMETER = "short-term";
export const LONG_TERM_POLICY_TYPE_URL_PARAMETER = "long-term";
export const CRITICAL_ILLNESS_POLICY_TYPE_URL_PARAMETER = "critical-illness";

/* Constants used for filtering UI*/
export const AGE_THRESHOLD_FILTERING_VALUE = 55;

/* Also constants for filtering UI, specifically filtering keys*/
export const AGED_FILTERING_KEY = "aged";
export const AGE_THRESHOLD_FILTERING_KEY = "ageThreshold";
export const POLICY_TYPE_FILTERING_KEY = "policyType";

export const IR_SITE_CONFIGURATION = {
	[IR_AUTO_INSURANCE_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
		isMediaAlphaPublisherVertical: true,
		companiesSortedByMediaAlphaBids: true,
		usesMultiStepModal: true,
		mediaAlphaModalSteps: ["zip"],
		serviceRightColumns: [
			{ fields: "companyType", label: "Company Type" },
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "amBestRating", label: "AM Best Rating" },
		],
		usesMediaAlphaBanner: true,
	},
	[IR_LIFE_INSURANCE_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[IR_HOMEOWNERS_INSURANCE_DEFAULT_PATH]: {
		preventRenderingCompanyListHeader: true,
		isMediaAlphaPublisherVertical: true,
		companiesSortedByMediaAlphaBids: true,
	},
	[IR_HEALTH_INSURANCE_DEFAULT_PATH]: {
		companyListHeaderParts: [
			"Provider",
			"Company Type",
			"Year Founded",
			"BBB Rating",
			"Why We Suggest",
		],
		serviceRightColumns: [
			{ fields: "companyType", label: "Company Type" },
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "bbbRating", label: "BBB Rating" },
		],
	},
	[IR_PET_INSURANCE_DEFAULT_PATH]: {
		showFeaturedCompany: true,
		preventRenderingCompanyListHeader: true,
	},
	[IR_RENTERS_INSURANCE_DEFAULT_PATH]: {
		companyListHeaderParts: [
			"Provider",
			"Company Type",
			"Year Founded",
			"BBB Rating",
			"Why We Suggest",
		],
		serviceRightColumns: [
			{ fields: "companyType", label: "Company Type" },
			{ fields: "yearFounded", label: "Year Founded" },
			{ fields: "bbbRating", label: "BBB Rating" },
		],
	},
	[DISABILITY_INSURANCE_DEFAULT_PATH]: {
		companyListHeaderParts: [
			"Provider",
			"Lowest Cost Plan",
			"AM Best Rating",
			"Year Founded",
			"Why We Suggest",
		],
		serviceRightColumns: [
			{
				fields: "minimumCostPerMonth",
				label: "Lowest Cost Plan",
				preFormatterConversions: {
					currency: {
						isConvertedToCurrency: true,
					},
				},
				formatter: (minimumCostPerMonth) => `$${minimumCostPerMonth}/mo`,
			},
			{ fields: "amBestRating", label: "AM Best Rating" },
			{ fields: "yearFounded", label: "Year Founded" },
		],
		filteringInformation: {
			filterFunctions: {
				[POLICY_TYPE_FILTERING_KEY]: filterByPolicyType,
			},
			urlPathFilteringConfiguration: {
				[SHORT_TERM_POLICY_TYPE_URL_PARAMETER]: [
					{
						filteringKey: POLICY_TYPE_FILTERING_KEY,
						filterValue: SHORT_TERM_POLICY_TYPE_URL_PARAMETER,
					},
				],
				[LONG_TERM_POLICY_TYPE_URL_PARAMETER]: [
					{
						filteringKey: POLICY_TYPE_FILTERING_KEY,
						filterValue: LONG_TERM_POLICY_TYPE_URL_PARAMETER,
					},
				],
				[CRITICAL_ILLNESS_POLICY_TYPE_URL_PARAMETER]: [
					{
						filteringKey: POLICY_TYPE_FILTERING_KEY,
						filterValue: CRITICAL_ILLNESS_POLICY_TYPE_URL_PARAMETER,
					},
				],
			},
		},
	},
	[BUSINESS_INSURANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[TRAVEL_INSURANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[EVENT_INSURANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: false,
	},
	[IR_WHOLE_LIFE_INSURANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[VISION_INSURANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[IR_PHONE_INSURANCE_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};
